import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTenderFailuresPage() {
  return <LatamAgentPage locale="es-MX" agentKey="tender_failures" />;
}
